import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export function NotFound() {
  useEffect(() => {
    document.title = 'Page not found | DiligenceGPT™';
    let robots = document.head.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.name = 'robots';
      document.head.appendChild(robots);
    }
    robots.content = 'noindex';
    return () => robots?.remove();
  }, []);
  return <main id="main" className="bg-ink" data-id="element-1500" data-mp="1f23s1nhq2cl1">
      <div className="mx-auto flex w-full max-w-[720px] flex-col items-center px-4 py-28 text-center sm:px-6" data-id="element-1501" data-mp="1f1133l3ymk7r">
        <p className="font-mono text-xs text-lime" data-id="element-1502" data-mp="1nvfp06izwszu">404</p>
        <h1 className="sf-display mt-4 text-[36px] leading-tight text-text-primary sm:text-[48px]" data-id="element-1503" data-mp="1nuxk6li9p6gb">This page doesn’t exist.</h1>
        <p className="mt-4 text-base text-text-secondary" data-id="element-1504" data-mp="1ssfmvu5oypfv">The link may be outdated. Try the homepage or browse all tools.</p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-1505" data-mp="1nvlwv89fl0rr">
          <Link to="/tools" className="inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-lime px-6 py-3 text-sm font-semibold text-ink hover:bg-[#2B1E7A] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-2" data-id="element-1506" data-mp="1ntr8fjyyaqix">
            Browse Tools
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-1507" data-mp="26mv4td3jzhh8" />
          </Link>
          <Link to="/" className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-hairline bg-panel px-6 py-3 text-sm font-semibold text-text-primary hover:bg-elevated focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-1508" data-mp="22kqbygkxiovn">
            Go to homepage
          </Link>
        </div>
      </div>
    </main>;
}